import { render, staticRenderFns } from "./BotManageHub.vue?vue&type=template&id=250852e5&scoped=true&"
import script from "./BotManageHub.vue?vue&type=script&lang=js&"
export * from "./BotManageHub.vue?vue&type=script&lang=js&"
import style0 from "./BotManageHub.vue?vue&type=style&index=0&id=250852e5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250852e5",
  null
  
)

export default component.exports